var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.status == "adding"
      ? _c("div", [
          _c("h1", [_vm._v("Add Pass(es)")]),
          _c("div", { staticClass: "field is-clearfix" }, [
            _c("label", { staticClass: "label" }, [_vm._v("First Name:")]),
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.firstName,
                    expression: "firstName"
                  }
                ],
                staticClass: "input is-primary",
                attrs: {
                  type: "text",
                  required: "",
                  placeholder: "First Name"
                },
                domProps: { value: _vm.firstName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.firstName = $event.target.value
                  }
                }
              })
            ])
          ]),
          _c("div", { staticClass: "field is-clearfix" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Last Name:")]),
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.lastName,
                    expression: "lastName"
                  }
                ],
                staticClass: "input is-primary",
                attrs: { type: "text", required: "", placeholder: "Last Name" },
                domProps: { value: _vm.lastName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.lastName = $event.target.value
                  }
                }
              })
            ])
          ]),
          _c(
            "div",
            { staticClass: "field is-clearfix" },
            [
              _c("label", { staticClass: "label" }, [_vm._v("Email:")]),
              _c("EmailField", {
                attrs: {
                  email: _vm.email,
                  valid: _vm.emailValid,
                  placeholder: "Email Address"
                },
                on: {
                  "update:email": function($event) {
                    _vm.email = $event
                  },
                  "update:valid": function($event) {
                    _vm.emailValid = $event
                  }
                }
              })
            ],
            1
          ),
          false
            ? _c("div", { staticClass: "field is-clearfix" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.addWillcall,
                      expression: "addWillcall"
                    }
                  ],
                  staticClass: "is-checkradio is-success",
                  attrs: { type: "checkbox", id: "showPreshowReminder" },
                  domProps: {
                    checked: Array.isArray(_vm.addWillcall)
                      ? _vm._i(_vm.addWillcall, null) > -1
                      : _vm.addWillcall
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.addWillcall,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.addWillcall = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.addWillcall = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.addWillcall = $$c
                      }
                    }
                  }
                }),
                _c("label", { attrs: { for: "showPreshowReminder" } }, [
                  _vm._v(" Apply to current performance ")
                ])
              ])
            : _vm._e(),
          false || _vm.addWillcall
            ? _c("div", { staticClass: "quantityPicker" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Number of passes:")
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.quantity,
                      expression: "quantity",
                      modifiers: { number: true }
                    }
                  ],
                  staticClass: "is-checkradio",
                  attrs: {
                    type: "radio",
                    id: "quantityone",
                    name: "quantity",
                    value: "1"
                  },
                  domProps: { checked: _vm._q(_vm.quantity, _vm._n("1")) },
                  on: {
                    change: function($event) {
                      _vm.quantity = _vm._n("1")
                    }
                  }
                }),
                _c("label", { attrs: { for: "quantityone" } }, [_vm._v("1")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.quantity,
                      expression: "quantity",
                      modifiers: { number: true }
                    }
                  ],
                  staticClass: "is-checkradio",
                  attrs: {
                    type: "radio",
                    id: "quantitytwo",
                    name: "quantity",
                    value: "2"
                  },
                  domProps: { checked: _vm._q(_vm.quantity, _vm._n("2")) },
                  on: {
                    change: function($event) {
                      _vm.quantity = _vm._n("2")
                    }
                  }
                }),
                _c("label", { attrs: { for: "quantitytwo" } }, [_vm._v("2")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.quantity,
                      expression: "quantity",
                      modifiers: { number: true }
                    }
                  ],
                  staticClass: "is-checkradio",
                  attrs: {
                    type: "radio",
                    id: "quantitythree",
                    name: "quantity",
                    value: "3"
                  },
                  domProps: { checked: _vm._q(_vm.quantity, _vm._n("3")) },
                  on: {
                    change: function($event) {
                      _vm.quantity = _vm._n("3")
                    }
                  }
                }),
                _c("label", { attrs: { for: "quantitythree" } }, [_vm._v("3")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.quantity,
                      expression: "quantity",
                      modifiers: { number: true }
                    }
                  ],
                  staticClass: "is-checkradio",
                  attrs: {
                    type: "radio",
                    id: "quantityfour",
                    name: "quantity",
                    value: "4"
                  },
                  domProps: { checked: _vm._q(_vm.quantity, _vm._n("4")) },
                  on: {
                    change: function($event) {
                      _vm.quantity = _vm._n("4")
                    }
                  }
                }),
                _c("label", { attrs: { for: "quantityfour" } }, [_vm._v("4")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.quantity,
                      expression: "quantity",
                      modifiers: { number: true }
                    }
                  ],
                  staticClass: "is-checkradio",
                  attrs: {
                    type: "radio",
                    id: "quantityfive",
                    name: "quantity",
                    value: "255"
                  },
                  domProps: { checked: _vm._q(_vm.quantity, _vm._n("255")) },
                  on: {
                    change: function($event) {
                      _vm.quantity = _vm._n("255")
                    }
                  }
                }),
                _c("label", { attrs: { for: "quantityfive" } }, [_vm._v("5")])
              ])
            : _vm._e(),
          _c("div", { staticClass: "columns buttons" }, [
            _c("div", { staticClass: "column" }, [
              _c(
                "button",
                {
                  staticClass: "button is-fullwidth is-primary",
                  attrs: { disabled: _vm.valid },
                  on: {
                    click: function($event) {
                      return _vm.clear()
                    }
                  }
                },
                [_vm._v(" Clear ")]
              )
            ]),
            _c("div", { staticClass: "column" }, [
              _c(
                "button",
                {
                  staticClass: "button is-fullwidth is-primary",
                  attrs: { disabled: _vm.valid },
                  on: {
                    click: function($event) {
                      return _vm.add("Credit")
                    }
                  }
                },
                [_vm._v(" Apply ")]
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm.status == "added"
      ? _c("div", [
          _c("h3", [
            _vm._v("Pass created and sent to " + _vm._s(_vm.email) + "!")
          ]),
          _c("p", [
            _vm._v(
              " The pass may now be used at walk up or to purchase advance tickets online. "
            )
          ]),
          _vm._m(0),
          _c("div", { staticClass: "buttons is-centered" }, [
            _c(
              "button",
              {
                staticClass: "button",
                on: {
                  click: function($event) {
                    return _vm.clear()
                  }
                }
              },
              [_vm._v("Add another pass")]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "figure" }, [
      _c("img", {
        attrs: { src: "/img/illustration-email.png", alt: "email sent" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }